import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon_Close from '../Assets/Icons/Icon_Close.png';
import Icon_Color_EmailSent from '../Assets/Icons/Icon_Color_EmailSent.png';
import { Context_UI } from '../Contexts/Context_UI';
import { useStatus } from '../Contexts/Context_Status_Global';

export default function Subwindow_Modal_ResetPassword_EmailSent({ zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const Navigate = useNavigate();
    const { Confirmer_Respond } = useStatus();
    const Confirm = async () => {
        Confirmer_Respond(true, {}, true, "Window_ResetPassword_EmailSent");
    }

    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_ResetPassword_EmailSent");
    }

    useEffect(() => {
        const el = document.getElementById("Window_ResetPassword_EmailSent");
        if (el) {
            el.setAttribute("Visibility", "Open");
            el.setAttribute("State", isActive ? "Active" : "Inactive");
            el.style.zIndex = zIndex;
        }
    }, [zIndex, isActive]);

    return (
        <ui-subwindow Type='Modal' id='Window_ResetPassword_EmailSent' State='Inactive' Visibility='Close'>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    
                </h2>
                <button className='Subwindow_TitleBar_Control'>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='Subwindow_Content_Icon'>
                    <img src={Icon_Color_EmailSent} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                </div>

                <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "center", marginBottom: "10px" }}>
                    Reset password link sent
                </h2>
                
                <p className='General_Paragraph' style={{textAlign: "center", marginBottom: "10px"}}>
                    Please open the link sent to you by the system in order to proceed with the password reset. The password reset link will expire in <b>1 hour.</b>
                </p>
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Confirm}>
                    Close
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
